<template>
  <div>
    <!-- Header -->
    <div class="px-2 py-2">
      <Button
        v-if="!showFilter"
        label="Añadir filtro"
        @click="showFilter = true"
      />
      <Filter
        v-else
        :editFilter="editFilter"
        :filters="filters"
        :reportType="reportType"
        @save-filter="saveFilter"
        @cancel="handleCancel()"
      />
    </div>

    <!-- Datatable -->
    <DataTable :value="filters" class="px-2 mt-3">
      <template #empty>
        <div class="p-text-center">
          <span class="p-text-bold">No hay filtros</span>
        </div>
      </template>
      <Column header="Nombre - Título">
        <template #body="slotProps">
          <div class="flex flex-column gap-1">
            <div>{{ slotProps.data.nombre }}</div>
            <div>{{ slotProps.data.titulo }}</div>
          </div>
        </template>
      </Column>
      <Column header="Tipo">
        <template #body="slotProps">
          <div class="capitalize">
            {{ slotProps.data.tipoFiltroDto.nombreTipoFiltro }}
          </div>
        </template>
      </Column>
      <Column header="Clase">
        <template #body="slotProps">
          {{ slotProps.data.claseFiltroDto.nombreClaseFiltro }}
        </template>
      </Column>
      <Column header="Min - Max">
        <template #body="slotProps">
          <div v-if="slotProps.data.min && slotProps.data.max">
            {{ slotProps.data.min }} - {{ slotProps.data.max }}
          </div>
          <div v-else-if="slotProps.data.min && !slotProps.data.max">
            {{ slotProps.data.min }}
          </div>
          <div v-else-if="!slotProps.data.min && slotProps.data.max">
            {{ slotProps.data.max }}
          </div>
          <div v-else class="text-gray-400">-</div>
        </template>
      </Column>
      <Column>
        <template #body="slotProps">
          <div class="flex justify-content-end gap-2">
            <Button
              @click="handleEditFilter(slotProps.data)"
              icon="pi pi-pencil"
              :disabled="slotProps.data.idFiltro == editFilter?.idFiltro"
            />
            <Button
              @click="deleteFilter(slotProps.data.idFiltro)"
              icon="pi pi-trash"
              :disabled="slotProps.data.idFiltro == editFilter?.idFiltro"
              severity="danger"
            />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
import { ref, nextTick } from "vue";
import Button from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { useConfirm } from "primevue/useconfirm";

import Filter from "@/pages/_root/reports-dialog/form-four/Filter.vue";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const reportData = ref(null);
const reportType = ref(null);
const filters = ref([]);
const editFilter = ref(null);
const showFilter = ref(false);
const confirm = useConfirm();
// #endregion

// #region Functions
// Open the modal with the data
function loadFilters(data, type) {
  reportType.value = type;

  if (!data || Object.keys(data).length === 0) return;

  reportData.value = data;

  if (data.filtro) {
    filters.value = data.filtro;
  }
}

function handleEditFilter(filter) {
  showFilter.value = false;
  editFilter.value = JSON.parse(JSON.stringify(filter));

  nextTick(() => {
    showFilter.value = true;
  });
}

function deleteFilter(idFiltro) {
  confirm.require({
    message: "¿Desea borrar el filtro?",
    header: "Borrar",
    icon: "pi pi-exclamation-triangle",
    rejectClass: "p-button-secondary p-button-outlined",
    accept: async () => {
      filters.value = filters.value.filter(
        (filter) => filter.idFiltro !== idFiltro
      );
    },
  });
}

function saveFilter(filter) {
  const index = filters.value.findIndex((f) => f.idFiltro === filter.idFiltro);

  if (index === -1) {
    filters.value.push(filter);
  } else {
    filters.value[index] = filter;
  }

  handleCancel();
}

function handleCancel() {
  showFilter.value = false;
  editFilter.value = null;
}

function getData(registerId) {
  const filtersArray = filters.value;

  /*
    Si no existe el registerId, es que estamos creando un nuevo formulario. Por lo que no
    debemos pasar el idFiltro (ya que el back no lo necesita)
  */
  filtersArray.forEach((filter) => {
    if (!registerId) {
      delete filter.idFiltro;
    }
  });

  return filtersArray;
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  loadFilters,
  getData,
});
// #endregion
</script>
